import { z } from 'zod';
/** Every permission key in the system. Per-member overrides refer to these keys. */
export const PERMISSION_KEYS = [
    'family.view',
    'family.manage',
    'members.view',
    'members.manage',
    'members.invite',
    'permissions.manage',
    // Phase 2: ledger. See CLAUDE.md §3.5 and the permission table in docs/decisions.md.
    'accounts.manage_own',
    'accounts.manage_shared',
    'accounts.manage_others',
    'accounts.private',
    'categories.manage',
    'payees.manage',
    'transactions.record_own',
    'transactions.record_shared',
    'transactions.record_others',
    'transactions.reverse_own',
    'transactions.reverse_any',
    // Phase 3: multi-currency.
    'rates.manage',
    // Phase 4: debts. See docs/plans/phase-4.md.
    'debts.outside',
    'debts.family',
    'debts.on_behalf',
    'debts.plans',
    'people.manage',
    // Phase 5: budgets and children's limits. See docs/plans/phase-5.md.
    'budgets.view',
    'budgets.manage',
    'limits.manage',
    // Phase 6: reports. See docs/plans/phase-6.md.
    'reports.view',
];
export const permissionKeySchema = z.enum(PERMISSION_KEYS);
/**
 * "May mark own accounts as private." Nobody has it by default (not even the owner); only the
 * owner can grant it, per member, and never to a child.
 */
export const PRIVATE_ACCOUNTS_PERMISSION = 'accounts.private';
/** What each role can do before any per-member override is applied. */
export const ROLE_DEFAULT_PERMISSIONS = {
    owner: PERMISSION_KEYS.filter((key) => key !== PRIVATE_ACCOUNTS_PERMISSION),
    parent: [
        'family.view',
        'family.manage',
        'members.view',
        'members.manage',
        'members.invite',
        'accounts.manage_own',
        'accounts.manage_shared',
        'accounts.manage_others',
        'categories.manage',
        'payees.manage',
        'transactions.record_own',
        'transactions.record_shared',
        'transactions.record_others',
        'transactions.reverse_own',
        'transactions.reverse_any',
        'rates.manage',
        'debts.outside',
        'debts.family',
        'debts.on_behalf',
        'debts.plans',
        'people.manage',
        'budgets.view',
        'budgets.manage',
        'limits.manage',
        'reports.view',
    ],
    member: [
        'family.view',
        'members.view',
        'accounts.manage_own',
        'transactions.record_own',
        'transactions.record_shared',
        'transactions.reverse_own',
        'debts.outside',
        'debts.family',
        'debts.plans',
    ],
    child: [
        'family.view',
        'members.view',
        'accounts.manage_own',
        'transactions.record_own',
        'transactions.reverse_own',
        'debts.family',
    ],
};
//# sourceMappingURL=permissions.js.map